import React, { useState } from 'react';

function CustomerGroups({ showToast }) {
  const [showModal, setShowModal] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [viewMode, setViewMode] = useState('grid'); // 'grid', 'list', 'table'

  const [groups, setGroups] = useState([
    {
      id: 1,
      code: 'VIP',
      name: 'VIP',
      category: 'Phân khúc',
      description: 'Khách hàng VIP có giá trị cao',
      criteria: 'Dư nợ > 50 tỷ hoặc Tài sản gửi > 100 tỷ',
      riskWeight: 1.0,
      customerCount: 12,
      totalDebt: 850000000000,
      status: 'Hoạt động',
      createdDate: '01/01/2026'
    },
    {
      id: 2,
      code: 'SME',
      name: 'Doanh nghiệp vừa và nhỏ',
      category: 'Phân khúc',
      description: 'Doanh nghiệp vừa và nhỏ',
      criteria: 'Doanh thu < 100 tỷ/năm',
      riskWeight: 1.2,
      customerCount: 156,
      totalDebt: 1250000000000,
      status: 'Hoạt động',
      createdDate: '01/01/2026'
    },
    {
      id: 3,
      code: 'CORP',
      name: 'Doanh nghiệp lớn',
      category: 'Phân khúc',
      description: 'Doanh nghiệp lớn và tập đoàn',
      criteria: 'Doanh thu >= 100 tỷ/năm',
      riskWeight: 1.1,
      customerCount: 45,
      totalDebt: 3500000000000,
      status: 'Hoạt động',
      createdDate: '01/01/2026'
    },
    {
      id: 4,
      code: 'RETAIL',
      name: 'Khách hàng cá nhân',
      category: 'Phân khúc',
      description: 'Khách hàng cá nhân bán lẻ',
      criteria: 'Cá nhân, không thuộc VIP',
      riskWeight: 1.3,
      customerCount: 2847,
      totalDebt: 450000000000,
      status: 'Hoạt động',
      createdDate: '01/01/2026'
    },
    {
      id: 5,
      code: 'HIGH-RISK',
      name: 'Rủi ro cao',
      category: 'Rủi ro',
      description: 'Khách hàng có mức độ rủi ro cao',
      criteria: 'Nợ quá hạn > 30 ngày hoặc Điểm rủi ro < 600',
      riskWeight: 2.5,
      customerCount: 23,
      totalDebt: 125000000000,
      status: 'Hoạt động',
      createdDate: '10/01/2026'
    },
    {
      id: 6,
      code: 'NPL',
      name: 'Nợ xấu',
      category: 'Rủi ro',
      description: 'Nhóm nợ xấu cần xử lý',
      criteria: 'Nợ quá hạn > 90 ngày',
      riskWeight: 5.0,
      customerCount: 8,
      totalDebt: 45000000000,
      status: 'Hoạt động',
      createdDate: '15/01/2026'
    },
    {
      id: 7,
      code: 'STARTUP',
      name: 'Startup',
      category: 'Phân khúc',
      description: 'Doanh nghiệp khởi nghiệp',
      criteria: 'Doanh nghiệp < 3 năm tuổi',
      riskWeight: 1.8,
      customerCount: 67,
      totalDebt: 89000000000,
      status: 'Hoạt động',
      createdDate: '20/02/2026'
    },
    {
      id: 8,
      code: 'EXPORT',
      name: 'Xuất khẩu',
      category: 'Phân khúc',
      description: 'Doanh nghiệp xuất khẩu',
      criteria: 'Doanh thu XK > 30% tổng DT',
      riskWeight: 1.15,
      customerCount: 34,
      totalDebt: 280000000000,
      status: 'Hoạt động',
      createdDate: '25/02/2026'
    }
  ]);

  const [formData, setFormData] = useState({
    code: '',
    name: '',
    category: 'Phân khúc',
    description: '',
    criteria: '',
    riskWeight: 1.0
  });

  const filteredGroups = groups.filter(group => {
    const matchesSearch = group.name.toLowerCase().includes(searchText.toLowerCase()) ||
      group.code.toLowerCase().includes(searchText.toLowerCase());
    const matchesCategory = !categoryFilter || group.category === categoryFilter;
    const matchesStatus = !statusFilter || group.status === statusFilter;
    return matchesSearch && matchesCategory && matchesStatus;
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const openCreateModal = () => {
    setEditingGroup(null);
    setFormData({
      code: '',
      name: '',
      category: 'Phân khúc',
      description: '',
      criteria: '',
      riskWeight: 1.0
    });
    setShowModal(true);
  };

  const openEditModal = (group) => {
    setEditingGroup(group);
    setFormData({
      code: group.code,
      name: group.name,
      category: group.category,
      description: group.description,
      criteria: group.criteria,
      riskWeight: group.riskWeight
    });
    setShowModal(true);
  };

  const handleSave = (e) => {
    e.preventDefault();

    if (!formData.code || !formData.name) {
      showToast('Vui lòng điền đầy đủ thông tin', 'warning');
      return;
    }

    if (editingGroup) {
      setGroups(groups.map(group =>
        group.id === editingGroup.id
          ? { ...group, ...formData }
          : group
      ));
      showToast('Đã cập nhật nhóm khách hàng thành công', 'success');
    } else {
      const newGroup = {
        id: groups.length > 0 ? Math.max(...groups.map(g => g.id)) + 1 : 1,
        ...formData,
        customerCount: 0,
        totalDebt: 0,
        status: 'Hoạt động',
        createdDate: new Date().toLocaleDateString('vi-VN')
      };
      setGroups([...groups, newGroup]);
      showToast('Đã tạo nhóm khách hàng mới thành công', 'success');
    }

    setShowModal(false);
  };

  const deleteGroup = (groupId) => {
    const group = groups.find(g => g.id === groupId);
    if (group.customerCount > 0) {
      showToast('Không thể xóa nhóm đang có khách hàng', 'warning');
      return;
    }
    if (window.confirm('Bạn có chắc chắn muốn xóa nhóm này?')) {
      setGroups(groups.filter(group => group.id !== groupId));
      showToast('Đã xóa nhóm khách hàng thành công', 'success');
    }
  };

  const toggleStatus = (groupId) => {
    setGroups(groups.map(group =>
      group.id === groupId
        ? { ...group, status: group.status === 'Hoạt động' ? 'Không hoạt động' : 'Hoạt động' }
        : group
    ));
    showToast('Đã cập nhật trạng thái', 'success');
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(amount);
  };

  const getRiskWeightBadge = (weight) => {
    if (weight >= 3.0) return { class: 'danger', text: 'Rất cao' };
    if (weight >= 2.0) return { class: 'warning', text: 'Cao' };
    if (weight >= 1.5) return { class: 'info', text: 'Trung bình' };
    return { class: 'success', text: 'Thấp' };
  };

  const getCategoryBadge = (category) => {
    return category === 'Rủi ro' ? 'danger' : 'primary';
  };

  const getTotalCustomers = () => {
    return groups.reduce((sum, g) => sum + g.customerCount, 0);
  };

  const getTotalDebt = () => {
    return groups.reduce((sum, g) => sum + g.totalDebt, 0);
  };

  return (
    <div className="container-fluid p-4">
      <div className="page-header-sticky">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 className="mb-1">
              <i className="bi bi-people-fill me-2"></i>
              Quản lý Nhóm khách hàng
            </h2>
            <p className="text-muted mb-0">Phân loại và quản lý các nhóm khách hàng</p>
          </div>
          <button className="btn btn-primary" onClick={openCreateModal}>
            <i className="bi bi-plus-circle me-1"></i>
            Tạo nhóm mới
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="card mb-3">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-5">
              <input
                type="text"
                className="form-control"
                placeholder="Tìm kiếm theo tên, mã nhóm..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <select
                className="form-select"
                value={categoryFilter}
                onChange={(e) => setCategoryFilter(e.target.value)}
              >
                <option value="">Tất cả phân loại</option>
                <option value="Phân khúc">Phân khúc</option>
                <option value="Rủi ro">Rủi ro</option>
              </select>
            </div>
            <div className="col-md-2">
              <select
                className="form-select"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">Tất cả trạng thái</option>
                <option value="Hoạt động">Hoạt động</option>
                <option value="Không hoạt động">Không hoạt động</option>
              </select>
            </div>
            <div className="col-md-2">
              <div className="btn-group w-100" role="group">
                <button
                  className={`btn ${viewMode === 'grid' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('grid')}
                  title="Xem dạng lưới"
                >
                  <i className="bi bi-grid-3x3-gap"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('list')}
                  title="Xem dạng danh sách"
                >
                  <i className="bi bi-list-ul"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'table' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('table')}
                  title="Xem dạng bảng"
                >
                  <i className="bi bi-table"></i>
                </button>
              </div>
            </div>
            <div className="col-md-1">
              <button
                className="btn btn-outline-secondary w-100"
                onClick={() => {
                  setSearchText('');
                  setCategoryFilter('');
                  setStatusFilter('');
                  showToast('Đã xóa bộ lọc', 'info');
                }}
                title="Xóa lọc"
              >
                <i className="bi bi-x-circle"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Statistics */}
      <div className="row mb-3">
        <div className="col-md-3">
          <div className="card border-left-primary">
            <div className="card-body">
              <div className="text-primary font-weight-bold mb-1">Tổng nhóm</div>
              <div className="h5 mb-0">{groups.length}</div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card border-left-success">
            <div className="card-body">
              <div className="text-success font-weight-bold mb-1">Tổng khách hàng</div>
              <div className="h5 mb-0">{getTotalCustomers().toLocaleString()}</div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card border-left-info">
            <div className="card-body">
              <div className="text-info font-weight-bold mb-1">Nhóm phân khúc</div>
              <div className="h5 mb-0">{groups.filter(g => g.category === 'Phân khúc').length}</div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card border-left-danger">
            <div className="card-body">
              <div className="text-danger font-weight-bold mb-1">Nhóm rủi ro</div>
              <div className="h5 mb-0">{groups.filter(g => g.category === 'Rủi ro').length}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Total Debt Card */}
      <div className="card mb-3 bg-light">
        <div className="card-body">
          <h5><i className="bi bi-cash-stack text-warning me-2"></i>Tổng dư nợ theo nhóm</h5>
          <h3 className="text-warning">{formatCurrency(getTotalDebt())}</h3>
        </div>
      </div>

      {/* Groups Table */}
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Mã nhóm</th>
                  <th>Tên nhóm</th>
                  <th>Phân loại</th>
                  <th>Tiêu chí</th>
                  <th>Hệ số rủi ro</th>
                  <th>Số KH</th>
                  <th>Tổng dư nợ</th>
                  <th>Trạng thái</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>
                {filteredGroups.length > 0 ? (
                  filteredGroups.map((group) => {
                    const riskBadge = getRiskWeightBadge(group.riskWeight);
                    return (
                      <tr key={group.id}>
                        <td><strong>{group.code}</strong></td>
                        <td>{group.name}</td>
                        <td>
                          <span className={`badge bg-${getCategoryBadge(group.category)}`}>
                            {group.category}
                          </span>
                        </td>
                        <td><small className="text-muted">{group.criteria}</small></td>
                        <td>
                          <span className={`badge bg-${riskBadge.class}`}>
                            {group.riskWeight} - {riskBadge.text}
                          </span>
                        </td>
                        <td>
                          <span className="badge bg-info">{group.customerCount.toLocaleString()}</span>
                        </td>
                        <td><small className="text-primary">{formatCurrency(group.totalDebt)}</small></td>
                        <td>
                          <span
                            className={`badge bg-${group.status === 'Hoạt động' ? 'success' : 'secondary'}`}
                            onClick={() => toggleStatus(group.id)}
                            style={{ cursor: 'pointer' }}
                            title="Click để thay đổi trạng thái"
                          >
                            {group.status}
                          </span>
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-primary me-1"
                            onClick={() => openEditModal(group)}
                            title="Chỉnh sửa"
                          >
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => deleteGroup(group.id)}
                            title="Xóa"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center text-muted py-4">
                      <i className="bi bi-inbox fs-1"></i>
                      <p className="mt-2">Không tìm thấy nhóm khách hàng nào</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingGroup ? 'Chỉnh sửa nhóm khách hàng' : 'Tạo nhóm mới'}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleSave}>
                <div className="modal-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Mã nhóm <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="code"
                        className="form-control"
                        value={formData.code}
                        onChange={handleInputChange}
                        placeholder="VD: VIP, SME"
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Tên nhóm <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Tên nhóm khách hàng"
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Phân loại</label>
                      <select
                        name="category"
                        className="form-select"
                        value={formData.category}
                        onChange={handleInputChange}
                      >
                        <option value="Phân khúc">Phân khúc</option>
                        <option value="Rủi ro">Rủi ro</option>
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Hệ số rủi ro</label>
                      <input
                        type="number"
                        name="riskWeight"
                        className="form-control"
                        value={formData.riskWeight}
                        onChange={handleInputChange}
                        step="0.1"
                        min="0.1"
                        max="10"
                      />
                      <small className="text-muted">Từ 0.1 đến 10.0</small>
                    </div>
                    <div className="col-md-12">
                      <label className="form-label">Mô tả</label>
                      <textarea
                        name="description"
                        className="form-control"
                        value={formData.description}
                        onChange={handleInputChange}
                        rows="2"
                        placeholder="Mô tả nhóm khách hàng"
                      ></textarea>
                    </div>
                    <div className="col-md-12">
                      <label className="form-label">Tiêu chí phân loại</label>
                      <textarea
                        name="criteria"
                        className="form-control"
                        value={formData.criteria}
                        onChange={handleInputChange}
                        rows="2"
                        placeholder="VD: Dư nợ > 50 tỷ, Doanh thu < 100 tỷ/năm"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Hủy
                  </button>
                  <button type="submit" className="btn btn-primary">
                    <i className="bi bi-save me-2"></i>
                    {editingGroup ? 'Cập nhật' : 'Tạo mới'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomerGroups;
